import { VolumeNetworkList } from '@/components/resources/VolumeNetworkList';

export function NetworksPage() {
  return <VolumeNetworkList kind="network" />;
}
